module.exports = __webpack_public_path__ + "Roboto-Regular.8304e77e1181189f9c79.eot";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Regular.eot
// module id = ../../../../../src/assets/fonts/Roboto-Regular.eot
// module chunks = styles